import {
  regexHaveLowerCase,
  regexHaveNumber,
  regexHaveUppercase,
} from "@/utils/functions";
import RegisterAccessView from "./view";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import useAccessForm from "../hooks/useAccessForm";

export default function RegisterAccess() {
  const navigate = useNavigate();

  const {
    toggleModal,
    isVisibleModal,
    isLoading,
    isDisabled,
    register,
    handleSubmit,
    error,
    errorPlate,
    password,
    confirmPassword,
    success,
  } = useAccessForm();

  const [isVisiblePassword, setIsVisiblePassword] = useState(false);
  const [isVisibleConfirmPassword, setIsVisibleConfirmPassword] =
    useState(false);

  const goBack = () => navigate(-1);

  const toggleIsVisiblePassword = () =>
    setIsVisiblePassword((isVisiblePassword) => !isVisiblePassword);
  const toggleIsVisibleConfirmPassword = () =>
    setIsVisibleConfirmPassword(
      (isVisibleConfirmPassword) => !isVisibleConfirmPassword,
    );

  const goToLogin = () => navigate("/?auth=true");

  const items = [
    {
      text: "Ter no Mínimo 8 Caracteres e no Máximo 20 Caracteres",
      success: password?.length >= 8 && password?.length <= 20,
    },
    {
      text: "Pelo Menos 1 Letra Maiúscula",
      success: regexHaveUppercase.test(password),
    },
    {
      text: "Pelo Menos 1 Letra Minúscula",
      success: regexHaveLowerCase.test(password),
    },
    {
      text: "Pelo Menos 1 Número",
      success: regexHaveNumber.test(password),
    },
  ];

  const itemsConfirm = [
    {
      text: "As senhas precisam ser iguais",
      success:
        !items?.find((item) => !item.success) && password === confirmPassword,
    },
  ];

  const [validatesPassword, setValidatesPassword] = useState(items);
  const [validatesConfirmPassword, setValidatesConfirmPassword] =
    useState(itemsConfirm);

  useEffect(() => {
    setValidatesPassword(items);
    setValidatesConfirmPassword(itemsConfirm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [password, confirmPassword]);

  return (
    <RegisterAccessView
      goBack={goBack}
      isDisabled={isDisabled || !itemsConfirm?.[0]?.success}
      goToLogin={goToLogin}
      validatesPassword={validatesPassword}
      validatesConfirmPassword={validatesConfirmPassword}
      isVisiblePassword={isVisiblePassword}
      isVisibleConfirmPassword={isVisibleConfirmPassword}
      toggleIsVisiblePassword={toggleIsVisiblePassword}
      toggleIsVisibleConfirmPassword={toggleIsVisibleConfirmPassword}
      error={error}
      errorPlate={errorPlate}
      isLoading={isLoading}
      success={success}
      register={register}
      handleSubmit={handleSubmit}
      toggleModal={toggleModal}
      isVisibleModal={isVisibleModal}
    />
  );
}
